export const ONE_DAY_COOKIE_EXPIRED_DATE = 1000 * 60 * 60 * 24;
export const THIRTY_DAYS_COOKIE_EXPIRED_DATE = 1000 * 60 * 60 * 24 * 30;

export const USE_FAVORITE_ADDRESS_COOKIE = '_useFavoriteAddress';
export const FAVORITE_DELIVERY_TYPE_COOKIE = 'favoriteDeliveryType';
export const PRIORITY_STORE_IDS_COOKIE = 'priorityStoreIds';
